import React from 'react';
import { FileInput } from 'components/common/FileInput/FileInput';
import styles from './fileFormInput.module.scss';
import classNames from 'classnames/bind';

type FileFormInputType = {
  className?: string;
  onChange: (file: FileFieldData | EmptyFileFieldData) => void;
  validTypes?: string[];
  errorBorderHint: boolean;
  url: string;
  file?: File;
  icon: any;
};

export const FileFormInput: React.FunctionComponent<FileFormInputType> = ({
  validTypes = ['application/zip', 'application/x-zip-compressed'],
  className,
  onChange,
  errorBorderHint,
  url,
  file,
  icon
}) => {
  const cssClassNames = classNames.bind(styles);

  const mainClassName = cssClassNames('fileFormInput', className, {
    showErrorBorder: errorBorderHint,
    showSolidBorder: url || file
  });

  const onFileChange = (file) => {
    if (!file) {
      onChange &&
        onChange({
          file: undefined,
          url: undefined
        });
      return;
    }

    onChange &&
      onChange({
        file,
        url: undefined
      });
  };

  return (
    <div className={mainClassName}>
      <FileInput
        validTypes={validTypes}
        url={url}
        file={file}
        icon={icon}
        onChange={onFileChange}
      />
    </div>
  );
};
